import { jsxs as h, jsx as s } from "react/jsx-runtime";
import { c as e } from "./index-65016bfa.mjs";
import { createContext as x, useContext as b, useState as v } from "react";
import n, { css as r } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as G } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { b as N } from "./useSlots-a1aa6a84.mjs";
import { CloseButton as k } from "./closeButton.js";
import { Icon as B } from "./icon.js";
import { c as M } from "./childrenCountCheck-785fa19a.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./iconButton.js";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "@fcamna/shared-icons";
const $ = x({ stroke: !1 }), S = n.div`
  &.Tag__container {
    ${({
  theme: {
    components: { tag: o }
  }
}) => r(o.Container)};
  }
`, W = n.span`
  &.Tag__title-wrapper {
    ${({
  theme: {
    components: { tag: o }
  }
}) => r(o.TitleWrapper)};
  }
`, P = n.div`
  &.Tag__icon-wrapper {
    ${({
  theme: {
    components: { tag: o }
  }
}) => r(o.IconWrapper)};
  }
`, y = n(k)`
  &.Tag__close-btn {
    ${({
  theme: {
    components: { tag: o }
  }
}) => r(o.CloseIconWrapper)};
  }
`, O = {
  accent: "info",
  success: "success",
  caution: "caution",
  danger: "danger",
  default: "default"
}, j = ({
  variant: o = "default",
  size: c = "medium",
  stroke: l,
  title: p,
  leadingIcon: t,
  onDelete: a,
  accessibilityOptions: m,
  className: u
}) => {
  const g = b($), T = g.size || c, _ = g.stroke || l, f = G({ label: "Tag" }), i = !!a;
  return /* @__PURE__ */ h(
    S,
    {
      className: e([
        "Tag",
        "Tag__container",
        `Tag__container--${o}`,
        `Tag__container--${T}`,
        { "Tag__container--stroke": _ },
        u
      ]),
      ...f,
      children: [
        t && (typeof t == "string" ? /* @__PURE__ */ s(
          B,
          {
            name: t,
            size: "xs",
            "data-testid": "leading-icon"
          }
        ) : /* @__PURE__ */ s(
          P,
          {
            className: e(["Tag__icon-wrapper"]),
            "data-testid": "leading-icon",
            children: t
          }
        )),
        /* @__PURE__ */ s(W, { className: e(["Tag__title-wrapper", `Tag__title-wrapper--${c}`]), children: p }),
        i && /* @__PURE__ */ s(
          y,
          {
            className: e(["Tag__close-btn", `Tag__close-btn--${o}`]),
            onClick: (d) => {
              d.preventDefault(), d.stopPropagation(), a && a(d);
            },
            size: "xxxsmall",
            color: O[o],
            accessibilityOptions: m
          }
        )
      ]
    }
  );
}, q = n.div`
  &.TagGroup__container {
    ${({
  theme: {
    components: { tag: o }
  }
}) => r(o.TagGroupContainer)};
  }
`, z = n.div`
  &.TagGroup__children-container {
    ${({
  theme: {
    components: { tag: o }
  }
}) => r(o.ChildrenContainer)};
  }
`, F = n.button`
  &.TagGroup__overflow-button {
    ${({
  theme: {
    components: { tag: o }
  }
}) => r(o.OverflowButton)};
  }
`, ao = ({
  overflowVariant: o = "default",
  stroke: c = !1,
  size: l = "medium",
  overflow: p = !1,
  children: t = [],
  onClick: a,
  visibleTags: m = 0,
  _maxTagCount: u,
  className: g
}) => {
  const T = G({ label: "Tag Group" }), [_, f] = v(!0), i = N(t, { tags: j }), C = i.tags.length - m, w = () => {
    f(!1), a && a();
  };
  return M({
    additionalInfo: `Maximin tags count exceeded. Max ${u} tags are allowed in TagsGroup.`,
    children: t,
    componentName: "TagsGroup",
    maxChildren: u
  }), /* @__PURE__ */ s($.Provider, { value: { size: l, stroke: c }, children: /* @__PURE__ */ s(
    q,
    {
      className: e(["TagsGroup", "TagGroup__container", g]),
      ...T,
      children: /* @__PURE__ */ h(
        z,
        {
          className: e([
            "TagGroup__children-container",
            "TagGroup__children-container--overflow",
            `TagGroup__children-container--${o}`
          ]),
          children: [
            _ && p ? i.tags.slice(0, m) : i.tags,
            p && _ && C > 0 && /* @__PURE__ */ h(
              F,
              {
                role: "button",
                onClick: w,
                className: e([
                  "TagGroup__overflow-button",
                  `TagGroup__overflow-button--${o}`,
                  `TagGroup__overflow-button--${l}`,
                  { "TagGroup__overflow-button--stroke": c }
                ]),
                children: [
                  "+",
                  C
                ]
              }
            )
          ]
        }
      )
    }
  ) });
};
export {
  j as Tag,
  ao as TagsGroup
};
